import React from 'react';

export interface MiniHtmlToolbarProps {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  onChange: (newValue: string) => void;
}

export const MiniHtmlToolbar: React.FC<MiniHtmlToolbarProps> = ({ textareaRef, onChange }) => {
  const insertTag = (tag: string, endTag: string = `</${tag}>`) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const val = textarea.value;
    const selectedText = val.substring(start, end);
    let replacement = `<${tag}>${selectedText}${endTag}`;

    if (tag === 'a') {
      const url = prompt('Enter link URL:');
      if (!url) return; // user cancelled
      replacement = `<a href="${url}">${selectedText || 'link'}</a>`;
    }

    const newVal = val.substring(0, start) + replacement + val.substring(end);
    onChange(newVal);

    // Restore focus and selection
    setTimeout(() => {
      textarea.focus();
      // Rough approximation of cursor position
      const newCursorPos = start + replacement.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  return (
    <div className="flex items-center gap-1 mb-1 px-1">
      <button
        type="button"
        onClick={() => insertTag('b')}
        className="px-1.5 py-0.5 text-ink-500 hover:text-ink-900 hover:bg-ink-100 rounded text-xs font-bold font-sans transition-colors"
        title="Bold"
      >
        B
      </button>
      <button
        type="button"
        onClick={() => insertTag('i')}
        className="px-1.5 py-0.5 text-ink-500 hover:text-ink-900 hover:bg-ink-100 rounded text-xs italic font-sans transition-colors"
        title="Italic"
      >
        I
      </button>
      <button
        type="button"
        onClick={() => insertTag('a')}
        className="px-1.5 py-0.5 text-ink-500 hover:text-ink-900 hover:bg-ink-100 rounded text-xs underline font-sans transition-colors"
        title="Link"
      >
        Link
      </button>
    </div>
  );
};
